import i18n from './top-n-sort-order.properties';

const TopNSortOrderInternal = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
} as const;

/** @deprecated Use the type instead. */
export const TopNSortOrder = {
  ...TopNSortOrderInternal,
  values: [...Object.values(TopNSortOrderInternal)],
  i18n,
} as const;

export type TopNSortOrder = keyof typeof TopNSortOrderInternal;
